module.exports = __webpack_public_path__ + "img/Small-Bevel-Attachment-11.f945c267.png";